// SCR-233's routes (NAV-020): the screen is the library's (`@nexus/ui/screens/notifications`,
// TASK-693), and `/customers/:orgId/notifications` is the customer page's Notifications tab
// (REQ-238): the customer `:tab` route resolves it to `CustomerPage`, under its tab bar. The proxy
// mounts the same screen in its own Admin area, so no route of its own remains here.
import type { ScreenRoute } from "../../router/route";

export const routes: ScreenRoute[] = [];
